
type NormalizedHistoricProcessState =
  | "ACTIVE"
  | "COMPLETED"
  | "EXTERNALLY_TERMINATED"
  | "INTERNALLY_TERMINATED"
  | "SUSPENDED"
  | "UNKNOWN";

function normalizeHistoricProcessState(
  raw: string | undefined | null,
): NormalizedHistoricProcessState {
  const s = (raw ?? "").trim().toUpperCase().replace(/\s+/g, "_");
  switch (s) {
    case "ACTIVE":
      return "ACTIVE";
    case "COMPLETED":
      return "COMPLETED";
    case "EXTERNALLY_TERMINATED":
      return "EXTERNALLY_TERMINATED";
    case "INTERNALLY_TERMINATED":
      return "INTERNALLY_TERMINATED";
    case "SUSPENDED":
      return "SUSPENDED";
    default:
      return "UNKNOWN";
  }
}

export function isHistoricProcessActive(raw: string | undefined | null): boolean {
  return normalizeHistoricProcessState(raw) === "ACTIVE";
}

export function getHistoricProcessStatePresentation(raw: string | undefined | null) {
  const normalized = normalizeHistoricProcessState(raw);
  switch (normalized) {
    case "ACTIVE":
      return {
        label: "En progreso",
        className: "border-violet-300 bg-violet-100 text-violet-900",
      };
    case "COMPLETED":
      return {
        label: "Completado",
        className: "border-emerald-300 bg-emerald-100 text-emerald-900",
      };
    case "EXTERNALLY_TERMINATED":
      return {
        label: "Cancelado",
        className: "border-rose-300 bg-rose-100 text-rose-900",
      };
    case "INTERNALLY_TERMINATED":
      return {
        label: "Terminado",
        className: "border-slate-300 bg-slate-100 text-slate-800",
      };
    case "SUSPENDED":
      return {
        label: "Suspendido",
        className: "border-amber-300 bg-amber-100 text-amber-950",
      };
    default:
      return {
        label: raw?.trim() ? raw.trim() : "Desconocido",
        className: "border-gray-300 bg-gray-100 text-gray-800",
      };
  }
}
